export function stringToBytes(str: string) {
    const bytes = []

    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i)

        // Extract the two bytes from the 16-bit charCode
        const byte1 = charCode & 0xff
        const byte2 = (charCode >> 8) & 0xff

        bytes.push(byte1)

        // Add the second byte only if it's not zero (for characters in the ASCII range)
        if (byte2 !== 0) {
            bytes.push(byte2)
        }
    }

    return bytes
}
